import { AppBar, AppBarSection, AppBarSpacer, Avatar } from '@progress/kendo-react-layout'
import React from 'react'
import { ChatApi } from '../../redux/api/ChatApi';
import ProfileImage from './ProfileImage';
import { Button } from "@progress/kendo-react-buttons";
import { useNavigate } from 'react-router-dom';

export default function Nav() {
    const navigate = useNavigate();
    const { data: userProfile } = ChatApi.useGetProfileQuery();
    return (
        <AppBar >
            <AppBarSection>
                <img src='/images/Host_Images/Chat/Logo.png' style={{ width: 40, height: 40 }}></img>
            </AppBarSection>
            <AppBarSection ><h3 className='chat-title' >Revelation helpdesk Chat</h3></AppBarSection>
            <AppBarSpacer />
            <AppBarSection>
                <ProfileImage />
            </AppBarSection>
        </AppBar >
    )
}
